import Vue from "vue";
import { Service } from "typedi";
import { AppModule } from "@/core/types/app-module";
import { ModalsService } from "~shared/services/modals.service";
import * as NotificationPlugin from "./plugins/notifications";
import * as PortalPlugin from "./plugins/portal";
import * as DateFiltersPlugin from "./plugins/date-filters.plugin";

@Service()
export class SharedModule implements AppModule {
  public install(vue: typeof Vue): Promise<void> | void {
    NotificationPlugin.install(vue);
    PortalPlugin.install(vue);
    DateFiltersPlugin.install(vue);

    Object.defineProperty(vue.prototype, "$modalsService", {
      get(): ModalsService {
        return vue.$container.get(ModalsService);
      },
    });

    Object.defineProperty(vue, "$modalsService", {
      get(): ModalsService {
        return vue.$container.get(ModalsService);
      },
    });
  }
}
